export const formatDateTime = (value: string) => {
  const d = new Date(value);

  const date = d.toLocaleDateString("en-GB"); // dd/MM/yyyy
  const time = d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `${date} ${time}`;
};